import {checkError, closeAlert, receiveErrorAlert, receiveSuccessAlert} from "../commonsActions";
import {
    deletePlayerFolder,
    getPlayerFolders,
    savePlayerFolder,
    updatePlayerFolder
} from "../../helpers/playerFolderService";

export const FETCH_PLAYER_FOLDERS_BEGIN = 'FETCH_PLAYER_FOLDERS_BEGIN';
export const FETCH_PLAYER_FOLDERS_SUCCESS = 'FETCH_PLAYER_FOLDERS_SUCCESS';
export const FETCH_PLAYER_FOLDERS_ERROR = 'FETCH_PLAYER_FOLDERS_ERROR';

/*
 * action creators
 */

const fetchPlayerFoldersSuccess = res => ({
    type: FETCH_PLAYER_FOLDERS_SUCCESS,
    payload: {
        playerFolders: res.data,
        numberOfElements: res.numberOfElements,
        totalElements: res.totalElements,
        totalPages: res.totalPages
    }
});

const fetchPlayerFoldersError = error => ({
    type: FETCH_PLAYER_FOLDERS_ERROR,
    payload: {
        error: error,
    }
});

export const fetchPlayerFolders = query => dispatch => {
    dispatch({type: FETCH_PLAYER_FOLDERS_BEGIN});
    return getPlayerFolders(query).then(res => {
        dispatch(fetchPlayerFoldersSuccess(res));
        return res;
    }, error => {
        dispatch(fetchPlayerFoldersError(error))
        dispatch(checkError(error));
        dispatch(receiveErrorAlert(error));
        setTimeout(() => {
            dispatch(closeAlert());
        }, 2000);
    })
};

export const saveNewPlayerFolder = folder => dispatch => {
    return savePlayerFolder(folder).then(res => {
        dispatch(receiveSuccessAlert('Success'));
        setTimeout(() => {
            dispatch(closeAlert());
        }, 2000);
        return res;
    })
};

export const updateSinglePlayerFolder = folder => dispatch => {
    return updatePlayerFolder(folder).then(res => {
        dispatch(receiveSuccessAlert('Update Successful'));
        setTimeout(() => {
            dispatch(closeAlert());
        }, 2000);
        return res;
    })
};

export const removePlayerFolder = folderId => dispatch => {
    return deletePlayerFolder(folderId).then(res => {
        return res;
    }, error => {
        dispatch(checkError(error));
        dispatch(receiveErrorAlert(error));
        setTimeout(() => {
            dispatch(closeAlert());
        }, 2000);
    })
};


// WEBPACK FOOTER //
// ./src/actions/player/playerFolderActions.js